import {ApiSortOrder} from '@/api/meta/odata';
import {StorageStore} from '@/store/types';
// import {deepClone} from '@/util';
import {UnwrapRef, computed, ref, watch} from 'vue';

const SortTypes = [
  {
    value: ApiSortOrder.Asc,
    text: 'aufsteigend',
  },
  {
    value: ApiSortOrder.Desc,
    text: 'absteigend',
  },
];

export function useFilterSort<F, S extends any[], T>(store: StorageStore<F, S, T>, emit: (event: 'close') => void) {
  function save() {
    store.filterSort([structuredClone(filters.value as F), structuredClone(originalSorts.value as S)]);
    emit('close');
  };
  function reset() {
    store.resetFilter(null);
    emit('close');
  };

  const origFilters = computed(() => {
    return store.filters;
  });
  const originalSorts = ref<S>(structuredClone(store.sorts) ?? []);
  const sorts = computed<UnwrapRef<S>>({
    get: () => originalSorts.value,
    set: (newVal: UnwrapRef<S>) => {
      if (newVal === null) {
        originalSorts.value = [] as UnwrapRef<S>;
        return;
      }

      originalSorts.value = newVal;
    },
  });
  const filters = ref<F>(structuredClone(store.filters));

  watch(origFilters, (newOrigFilter) => {
    filters.value = structuredClone(newOrigFilter) as UnwrapRef<F>;
  });


  return {
    save,
    reset,
    origFilters,
    SortTypes,
    sorts,
    filters,
  };
}
